export const sessionStorageService = {
  set: (key: string, value: unknown) => {
    try {
      const serialized = JSON.stringify(value);
      sessionStorage.setItem(key, serialized);
    } catch (err) {
      console.error(`Erro ao salvar no sessionStorage [${key}]`, err);
    }
  },

  get: <T = unknown>(key: string): T | null => {
    try {
      const item = sessionStorage.getItem(key);
      return item ? (JSON.parse(item) as T) : null;
    } catch (err) {
      console.error(`Erro ao ler do sessionStorage [${key}]`, err);
      return null;
    }
  },

  remove: (key: string) => {
    try {
      sessionStorage.removeItem(key);
    } catch (err) {
      console.error(`Erro ao remover do sessionStorage [${key}]`, err);
    }
  },
};
